import { h } from "preact";
import {useState} from "preact/hooks";
import cx from "classnames";
import "./index.less";

const Checkbox = ({children,className, onChange,...props}) => {
  const [checkbox, setCheckbox] = useState(false);
  return <label className={cx("xfe_common_checkbox", className)}>
    <span className={'icon_wrapper'}><span className={cx("icon", checkbox && 'checked')} /></span>
    <input type={"checkbox"} onChange={(e) => {
      setCheckbox(e.target.checked);
      onChange(e)
    }} {...props}/>
    <span className={"content"}>
      {children}
    </span>
  </label>
}

export default Checkbox;
